import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import CarlineGroup, { DisplayMode } from '../../entities/CarlineGroup'
import CarlineGridView from '../carline-grid-view'
import CarlineListView from '../carline-list-view'
import CarlineSelectionToggleButton from './CarlineSelectionToggleButton'
import style from './carlineSelection.css'
import EnterVehicleCodeButton from '../enter-vehicle-code-button'
import LoadingIndicatorWrapper from '../loading-indicator-wrapper'
import BuildabilitySwitcher from '../buildability-switcher'
import FastConfigurationButton from '../fast-configuration-button'
import BackgroundImageSwitcher from '../background-image-switcher'

export type Props = {
    carlineGroups: CarlineGroup[]
    displayMode: DisplayMode
    setDisplayMode: (displayMode: DisplayMode) => void
    isLoading: boolean
    carlineFiltersAreLoading: boolean
    displayBuildabilitySwitcher: boolean
    displayBackgroundImageSwitcher: boolean
    backgroundImageType: string
    carlineInRow?: number
}

const CarlineSelection: FunctionComponent<Props> = (props) => {
    const {
        carlineGroups,
        displayMode,
        setDisplayMode,
        isLoading,
        carlineFiltersAreLoading,
        displayBuildabilitySwitcher,
        displayBackgroundImageSwitcher,
        backgroundImageType,
        carlineInRow,
    } = props
    const { t } = useTranslation()

    const carlineGroupsElement = displayMode === 'list'
        ? <CarlineListView carlineGroups={carlineGroups} isLoading={isLoading} carlineFiltersAreLoading = {carlineFiltersAreLoading} backgroundImageType={backgroundImageType}/>
        : <CarlineGridView carlineGroups={carlineGroups} isLoading={isLoading} carlineFiltersAreLoading = {carlineFiltersAreLoading} carlineInRow={carlineInRow}/>

    return (
        <div className={style.container} data-testid="page-/carlines">
            <section className={style.headerContainer}>
                <h1 className={style.title}>
                    {t('carlineSelection.heading')}
                </h1>
                <ul className={style.optionList}>
                    {displayBackgroundImageSwitcher &&
                        <li>
                            <BackgroundImageSwitcher/>
                        </li>}
                    {displayBuildabilitySwitcher &&
                        <li>
                            <BuildabilitySwitcher/>
                        </li>}
                    <li>
                        <CarlineSelectionToggleButton
                            displayMode={displayMode}
                            setDisplayMode={setDisplayMode}
                        />
                    </li>
                    <li>
                        <EnterVehicleCodeButton/>
                    </li>
                    <li>
                        <FastConfigurationButton/>
                    </li>
                </ul>
            </section>
            <LoadingIndicatorWrapper isLoading={isLoading} className={style.loadingIndicator}>
                {carlineGroupsElement}
            </LoadingIndicatorWrapper>
        </div>
    )
}

export default CarlineSelection
